<template>
  <div class="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
    <h2 class="mb-6 text-xl font-semibold text-slate-900">
      Quick Facts
    </h2>
    <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <div v-for="(value, key) in quickFacts" :key="key" class="rounded-lg border border-slate-200 bg-slate-50 p-4">
        <div class="mb-1 text-sm font-medium text-slate-600">
          {{ key }}
        </div>
        <div class="text-lg font-semibold text-slate-900">
          {{ value }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
interface Props {
  quickFacts: Record<string, string>
  brandColor: string
}
defineProps<Props>()
</script>